import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const AdminSetup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSetup = async () => {
    setLoading(true);
    setResult(null);
    setError(null);

    try {
      const response = await axios.post(`${API}/setup-admin`);
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Ein Fehler ist aufgetreten');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl">Admin Setup</CardTitle>
          <CardDescription>
            Erstelle einen Standard-Admin-User, wenn du dich nicht anmelden kannst
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-600">
            Dieser Setup-Prozess erstellt einen Standard-Admin-User mit folgenden Zugangsdaten:
          </p>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <p className="text-sm font-mono"><strong>Username:</strong> admin</p>
            <p className="text-sm font-mono"><strong>Password:</strong> admin</p>
          </div>

          <Button 
            onClick={handleSetup} 
            disabled={loading}
            className="w-full"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Wird erstellt...
              </>
            ) : (
              'Admin-User erstellen'
            )}
          </Button>

          {result && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <div className="text-green-800">
                <p className="font-semibold mb-2">{result.message}</p>
                {result.username && (
                  <div className="space-y-1">
                    <p className="text-sm">Username: <strong>{result.username}</strong></p>
                    <p className="text-sm">Password: <strong>{result.password}</strong></p>
                    <Button 
                      onClick={() => navigate('/admin/login')}
                      className="mt-3 w-full bg-green-600 hover:bg-green-700"
                    >
                      Jetzt zum Admin-Login →
                    </Button>
                  </div>
                )}
                {result.admin_count && (
                  <p className="text-sm mt-2">
                    Es existieren bereits {result.admin_count} Admin-User.
                  </p>
                )}
              </div>
            </div>
          )}

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <div className="text-red-800">
                <p className="font-semibold">Fehler:</p>
                <p className="text-sm mt-1">{error}</p>
              </div>
            </div>
          )}

          <p className="text-xs text-gray-500 text-center">
            Hinweis: Dieser Vorgang erstellt nur einen Admin-User, wenn noch keiner existiert.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminSetup;
